// 1. First, create: modules/tour/tourActions.js
export const TOUR_ACTIONS = {
  SET_TOUR_STATUS: "SET_TOUR_STATUS",
  SET_WELCOME_MODAL: "SET_WELCOME_MODAL",
  SET_ACTIVE_TOUR: "SET_ACTIVE_TOUR",
  UPDATE_TOUR_STEP: "UPDATE_TOUR_STEP",
};

export const setTourStatus = (tourType, isCompleted) => ({
  type: TOUR_ACTIONS.SET_TOUR_STATUS,
  payload: { tourType, isCompleted },
});

export const setWelcomeModal = (isVisible) => ({
  type: TOUR_ACTIONS.SET_WELCOME_MODAL,
  payload: isVisible,
});

export const setActiveTour = (tourType) => ({
  type: TOUR_ACTIONS.SET_ACTIVE_TOUR,
  payload: tourType,
});
